import React, { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { useLang } from "../LanguageContext";
import { Reveal, Overline, LineReveal } from "./Reveal";
import { optImg } from "../lib/img";

const Featured = () => {
  const { t, images } = useLang();
  const IMAGES = images;
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const imgScale = useTransform(scrollYProgress, [0, 1], [1.15, 1]);
  const imgY = useTransform(scrollYProgress, [0, 1], ["-6%", "6%"]);

  return (
    <section ref={ref} className="relative bg-ink text-white overflow-hidden grain">
      <div className="absolute inset-0">
        <motion.img style={{ scale: imgScale, y: imgY }} src={optImg(IMAGES.gripper, 1600)} alt="" loading="lazy" decoding="async"
          className="h-[112%] w-full object-cover opacity-40" />
        <div className="absolute inset-0 bg-gradient-to-r from-ink via-ink/85 to-ink/40" />
      </div>

      <div className="relative z-10 max-w-[1500px] mx-auto px-6 md:px-10 py-28 md:py-44">
        <div className="max-w-xl">
          <Reveal><Overline dark>{t.featured.overline}</Overline></Reveal>
          <h2 className="font-serif font-light leading-[1.02] text-5xl md:text-7xl mt-7">
            <LineReveal>{t.featured.title}</LineReveal>
          </h2>
          <Reveal delay={0.15}>
            <p className="mt-8 text-white/75 text-lg font-light leading-relaxed">{t.featured.body}</p>
          </Reveal>
          <Reveal delay={0.25}>
            <button onClick={() => document.getElementById("products")?.scrollIntoView({ behavior: "smooth" })}
              className="btn-line group mt-10 border border-white/40 px-9 py-4 text-[12px] uppercase tracking-[0.22em]">
              <span className="group-hover:text-white transition-colors duration-300">{t.cta.learnMore}</span>
            </button>
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default Featured;
